/** API `authType` value for OAuth2 integrations. */
export const OAUTH2_AUTH_TYPE = 'OAUTH2';

/** API `authType` value for static token integrations (user-provided secret). */
export const TOKEN_AUTH_TYPE = 'TOKEN';

/** API `code` for the Pennylane OAuth2 integration. */
export const PENNYLANE_OAUTH2_CODE = 'PENNYLANE_OAUTH2';

/** API `code` for the Combo token integration. */
export const COMBO_TOKEN_CODE = 'COMBO_TOKEN';

/** API `code` for the Skello token integration. */
export const SKELLO_TOKEN_CODE = 'SKELLO_TOKEN';

/** Possible values for integration `status`. */
export const INTEGRATION_STATUSES = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  COMING_SOON: 'coming_soon',
};

export const INTEGRATION_STATUS_LABEL_KEYS = {
  [INTEGRATION_STATUSES.ACTIVE]: 'ADMIN.INTEGRATIONS.STATUS_ACTIVE',
  [INTEGRATION_STATUSES.COMING_SOON]: 'ADMIN.INTEGRATIONS.STATUS_COMING_SOON',
  [INTEGRATION_STATUSES.PAUSED]: 'ADMIN.INTEGRATIONS.STATUS_PAUSED',
};
